import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import assets from "../../../../assets/assets";
import axios from "axios";
import {
  IconController,
  LottieController,
} from "../../../Scripts/ImgController";
import { usePasswordAxiosConfig } from "../../../Config/axios";
import { distributionUrl } from "../../../Config/url";
import Ripples from "react-ripples";
const Wrapper = styled.div`
  position: relative;
  .border-CK {
    border: 1px solid #d1d5db;
    border-radius: 12px;
    padding: 24px;
    position: relative;
  }
  @media (max-width: 767px) {
    .border-CK {
      padding: 16px;
    }
  }
  .color-red {
    color: red;
  }
  .color-CK {
    color: #6b7280;
  }
  input {
    border: 3px solid #e0effe;
    padding: 14px;
    font-size: 14px;
    border-radius: 8px;
    width: 100%;
  }
  .password-input {
    position: relative;
    height: 100%;
  }
  .password-eye {
    position: absolute;
    right: 0;
    top: 0;
    padding: 16px 12px;
  }
`;

const ChangePassword = ({
  setCKPopup,
  setCKPopupType,
  setCKPopupMessage,
  oneRingRulesAll,
}) => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordConfirmation, setNewPasswordConfirmation] = useState("");
  const axiosConfig = usePasswordAxiosConfig();

  const currentInput = useRef();
  const newInput = useRef();
  const newConfirmationInput = useRef();

  const [showCurrentPassword, setShowCurrentPassword] = useState("password");
  const [showNewPassword, setShowNewPassword] = useState("password");
  const [showNewPasswordConfirmation, setShowNewPasswordConfirmation] =
    useState("password");
  const [canSendRequest, setCanSendRequest] = useState(false);
  const [requestSent, setRequestSent] = useState(false);
  useEffect(() => {
    document.title = "MMusic - Профайл - Нууц үг солих";
  }, []);

  useEffect(() => {
    if (
      currentPassword.length >= 6 &&
      newPassword.length >= 6 &&
      newPasswordConfirmation.length >= 6
    ) {
      setCanSendRequest(true);
    } else {
      setCanSendRequest(false);
    }
  }, [currentPassword, newPassword, newPasswordConfirmation]);

  const CPRevealHandler = () => {
    if (showCurrentPassword === "password") {
      setShowCurrentPassword("text");
    }
    if (showCurrentPassword === "text") {
      setShowCurrentPassword("password");
    }
  };
  const NPRevealHandler = () => {
    if (showNewPassword === "password") {
      setShowNewPassword("text");
    }
    if (showNewPassword === "text") {
      setShowNewPassword("password");
    }
  };
  const NPCRevealHandler = () => {
    if (showNewPasswordConfirmation === "password") {
      setShowNewPasswordConfirmation("text");
    }
    if (showNewPasswordConfirmation === "text") {
      setShowNewPasswordConfirmation("password");
    }
  };
  const changePasswordHandler = () => {
    if (canSendRequest) {
      setRequestSent(true);
      const data = {
        current: currentPassword,
        new: newPassword,
        new_confirmation: newPasswordConfirmation,
      };
      axios
        .put(
          distributionUrl + "panel-oauth/oauth/publisher:password",
          data,
          axiosConfig
        )
        .then((res) => {
          if (res.status === 200) {
            setCKPopupType("Success");
            setCKPopupMessage("passwordChanged");
            setCKPopup(true);
            setRequestSent(false);
            clearTheFields();
          }
        })
        .catch((err) => {
          if (err.response.status === 422) {
            if (err.response.data.errors.current != null) {
              setCKPopupType("Warning");
              setCKPopupMessage("currentPasswordWrong");
              setCKPopup(true);
              setRequestSent(false);
              return;
            }
            if (err.response.data.errors.new != null) {
              setCKPopupType("Warning");
              setCKPopupMessage("newPasswordMismatched");

              setRequestSent(false);
              setCKPopup(true);
            }
          }
          if (err.response.status === 401) {
            oneRingRulesAll("logout");
          }
          setRequestSent(false);
        });
    } else {
      setCKPopupType("Info");
      setCKPopupMessage("fillTheFields");
      setCKPopup(true);
    }
  };

  const clearTheFields = () => {
    setCurrentPassword("");
    setNewPassword("");
    setNewPasswordConfirmation("");
    currentInput.current.value = "";
    newInput.current.value = "";
    newConfirmationInput.current.value = "";
  };
  return (
    <Wrapper className="px-3 py-4 md:px-6 md:py-8">
      <div className="border-CK ">
        <div className="w-full md:w-1/2">
          {requestSent ? (
            <div
              className="absolute top-0 left-0 w-full h-full rounded-xl"
              style={{ background: "#a9b7d280", zIndex: "1001" }}
            >
              <div className="w-full h-full flex flex-row justify-center items-center">
                <LottieController
                  src={assets.lottie.loadingLottie}
                  className="w-32 h-32 flex flex-row justify-center"
                />
              </div>
            </div>
          ) : (
            ""
          )}
          <h5 className="font-bold text-sm pb-6">Нууц үг</h5>
          <h5 className="text-xs font-medium pb-8">
            Та нэвтрэх нууц үгээ солих боломжтой
          </h5>
          <div className="flex flex-col gap-8">
            <div className="flex flex-col gap-3">
              <h5 className="font-bold text-sm color-CK">
                Одоогын нууц үг<span className="color-red">*</span>
              </h5>
              <div className="password-input">
                <input
                  type={showCurrentPassword}
                  onChange={(value) => {
                    setCurrentPassword(value.target.value);
                  }}
                  placeholder="Одоогын нууц үг"
                  ref={currentInput}
                />
                <div
                  onClick={() => {
                    CPRevealHandler();
                  }}
                >
                  <IconController
                    src={
                      showCurrentPassword === "password"
                        ? assets.svg.passwordEye
                        : assets.svg.passwordEyeOff
                    }
                    className="password-eye cursor-pointer"
                  />
                </div>
              </div>
            </div>
            <div className="flex flex-col gap-3">
              <h5 className="font-bold text-sm color-CK">
                Шинэ нууц үг<span className="color-red">*</span>
              </h5>
              <div className="password-input">
                <input
                  type={showNewPassword}
                  onChange={(value) => {
                    setNewPassword(value.target.value);
                  }}
                  placeholder="Шинэ нууц үг"
                  ref={newInput}
                />
                <div
                  onClick={() => {
                    NPRevealHandler();
                  }}
                >
                  <IconController
                    src={
                      showNewPassword === "password"
                        ? assets.svg.passwordEye
                        : assets.svg.passwordEyeOff
                    }
                    className="password-eye cursor-pointer"
                  />
                </div>
              </div>
            </div>
            <div className="flex flex-col gap-3">
              <h5 className="font-bold text-sm color-CK">
                Шинэ нууц үг давтах<span className="color-red">*</span>
              </h5>
              <div className="password-input">
                <input
                  type={showNewPasswordConfirmation}
                  onChange={(value) => {
                    setNewPasswordConfirmation(value.target.value);
                  }}
                  placeholder="Шинэ нууц үг давтах"
                  ref={newConfirmationInput}
                />
                <div
                  onClick={() => {
                    NPCRevealHandler();
                  }}
                >
                  <IconController
                    src={
                      showNewPasswordConfirmation === "password"
                        ? assets.svg.passwordEye
                        : assets.svg.passwordEyeOff
                    }
                    className="password-eye cursor-pointer"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-row justify-center items-center pt-8">
          <div className="confirm-button">
            <Ripples color="#FFFFFF40" during={600} className="rounded-2xl">
              <div
                className="flex flex-row justify-center items-center px-3"
                onClick={() => {
                  changePasswordHandler();
                }}
              >
                <h5 className="text-xs font-medium py-2 pr-1">Нууц үг солих</h5>
                <IconController
                  src={assets.svg.passwordChange}
                  className="h-4 w-4"
                />
              </div>
            </Ripples>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default ChangePassword;
